import env from '../config/env';
import {getService, postBodyService} from "./base.service";
import permission from '../api/permissions.service';
import config from "../config/application";
import dictionary from '../config/dictionary';

//url
const readMessage = '/message/read/';
const createMessage = '/message/create';
const deleteMessage = '/message/delete';
const updateMessage = '/message/update';
const findByTypeUrl = '/message/findByType/';

class MessageService {
    async findByType(type, username) {
        let valid = await permission.validPermission(
            env.transaction.message,
            username,
            env.app.systemCode, dictionary.configApp.action.list);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.message.url}${findByTypeUrl}${type}`;
            return getService(url);
        } else {
            return valid;
        }
    }

    async getMessage(message, username) {
        let valid = await permission.validPermission(
            env.transaction.message,
            username,
            env.app.systemCode, dictionary.configApp.action.list);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.message.url}${readMessage}${message}`;
            return getService(url);
        } else {
            return valid;
        }
    }

    async getCreateMessage(message, username) {
        let valid = await permission.validPermission(
            env.transaction.message,
            username,
            env.app.systemCode, dictionary.configApp.action.add);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.message.url}${createMessage}`;
            return postBodyService(url, message);
        } else {
            return valid;
        }        
        
    }
    async getDeleteMessage(lsData, username) {
        let valid = await permission.validPermission(
            env.transaction.message,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.message.url}${deleteMessage}`;
        return postBodyService(url,lsData);
        } else {
            return valid;
        } 
        
    }
    async getUpdateMessage(message, username) {
        let valid = await permission.validPermission(
            env.transaction.message,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);
        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.message.url}${updateMessage}`;
            return postBodyService(url, message);
        } else {
            return valid;
        } 
        
    }
}
export default new MessageService();